import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/layout/AppShell";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell, PieChart, Pie } from "recharts";
import { PROJECT_STATUS } from "@/lib/discovery";

const COLORS = ["#0284C7", "#10B981", "#F59E0B", "#8B5CF6", "#3B82F6"];

export default function Reports() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/dashboard").then((r) => setData(r.data)); }, []);

  const statusData = data ? Object.entries(
    data.projects.reduce((acc, p) => { acc[p.status] = (acc[p.status] || 0) + 1; return acc; }, {})
  ).map(([k, v]) => ({ name: PROJECT_STATUS[k]?.label || k, value: v })) : [];

  const progressData = data ? data.projects.map((p) => ({ name: p.customer_name.split(" ")[0], progress: p.progress })) : [];

  return (
    <>
      <PageHeader title="Reports" subtitle="Portfolio view of discovery progress and status." />
      <div className="flex-1 px-6 py-8 lg:px-10">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="rounded-2xl border border-slate-200 bg-white p-6">
            <h3 className="font-heading text-base font-bold text-slate-900">Discovery Progress by Customer</h3>
            <div className="mt-6 h-64">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={progressData} layout="vertical" margin={{ left: 10 }}>
                  <XAxis type="number" domain={[0, 100]} tickLine={false} axisLine={false} fontSize={12} />
                  <YAxis type="category" dataKey="name" tickLine={false} axisLine={false} fontSize={12} width={90} />
                  <Bar dataKey="progress" radius={[0, 6, 6, 0]} fill="#0284C7" barSize={22} />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
          <div className="rounded-2xl border border-slate-200 bg-white p-6">
            <h3 className="font-heading text-base font-bold text-slate-900">Projects by Status</h3>
            <div className="mt-6 h-64">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie data={statusData} dataKey="value" nameKey="name" innerRadius={55} outerRadius={90} paddingAngle={3}>
                    {statusData.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>
            <div className="mt-2 flex flex-wrap justify-center gap-3">
              {statusData.map((s, i) => (
                <span key={s.name} className="flex items-center gap-1.5 text-xs font-medium text-slate-600">
                  <span className="h-2.5 w-2.5 rounded-full" style={{ background: COLORS[i % COLORS.length] }} /> {s.name}
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-6 rounded-2xl border border-dashed border-slate-300 bg-white p-8 text-center text-sm text-slate-400">
          More detailed reporting (pipeline readiness, module completion trends, consultant workload) will appear here as your portfolio grows.
        </div>
      </div>
    </>
  );
}
